<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="is-flex is-full-width" v-html="value" :class="classes"></div>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'HtmlEmbed',
  props: {
    value: {
      type: String
    },
    classes: {
      type: Array,
      default: () => []
    }
  }
};
</script>
